<script>
  import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
  import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
  import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
  import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
  import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
  import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
  import Icon from 'fa-svelte';
  import { getFacebookLink,getLinkedinLink,getTwitterLink } from './data.js';
  import { getTrad,language } from './js/AppState';
  import DataLoading from './js/DataLoading';
  import SGMSApi from './js/SGMSApi.js';
  import Logo from './Logo.svelte';

  let languages = [...DataLoading.languages]


  $: sortedLanguages = [...languages].sort((a, b) => {
    if (a.id === $language) return -1
    return 1
  })

  let footerMobileOpened = false
  let shareOpened = false
  let langOpened = false


  function toggleFooterMobile() {
    footerMobileOpened = !footerMobileOpened
  }
  function toggleShareMenu() {
    shareOpened = !shareOpened
  }
  function closeShare() {
    if(shareOpened) shareOpened = false
  }

  function openLanguageDropdown() {
    langOpened = true
  }

  function select(id, e) {

    SGMSApi.sendActionEvent(e, "mobile_footer_change_language." + id)
    language.set(id)
    langOpened = false
  }


  let infopopupOpened = false
  let infopopupTitle = ""
  let infopopupContent = ""

  function setInfoPopup(titleId, contentId, e) {

    SGMSApi.sendActionEvent(e, titleId)
    infopopupTitle = $getTrad(titleId)
    infopopupContent = $getTrad(contentId)

    SGMSApi.sendContentEvent(titleId, "SHOW")

    infopopupOpened = true
    footerMobileOpened = false
  }

  function closeInfoPopup(e) {
    SGMSApi.sendActionEvent(e, "close_infopopup")
    infopopupOpened = false
    footerMobileOpened = true
    SGMSApi.sendContentEvent(infopopupTitle, "HIDE")
  }

  function handleRSClick (id, e) {
    SGMSApi.sendActionEvent(e, id)
  }
</script>


{#if infopopupOpened}
<div class="infopopup">
  <div class="infopopup-close" on:click={closeInfoPopup} />
  <div class="infopopup-title">{infopopupTitle}</div>
  <div class="infopopup-content">{@html infopopupContent}</div>
</div>
{/if}

{#if footerMobileOpened}
  <div class="footer-mobile-menu">
      <div class="languages">
        {#if langOpened}
          <div class="dropdown">
            {#each sortedLanguages as l}
              <div on:click={select.bind(null, l.id)} class={"lang" + (l.id === language ? " selected" : "")}>
                {l.short}
              </div>
            {/each}
          </div>
        {:else}
          <div class="lang selected" on:click={openLanguageDropdown} ><Icon icon={faCaretDown} /> {$language}</div>
        {/if}
      </div>

      <div class="top">
        <div class="link" on:click|preventDefault={(e)=>{ setInfoPopup("footer_about", "footer_about_infopopup", e) }} >
          {$getTrad("footer_about")}
        </div>
        <div class="link" on:click|preventDefault={(e)=>{ setInfoPopup("footer_copyrights_popup_title", "footer_copyrights_popup", e) }} >
          {$getTrad("footer_credits")}
        </div>
        <div class="link" on:click|preventDefault={(e)=>{ setInfoPopup("footer_mentions", "footer_mentions_popup", e) }} >
          {$getTrad("footer_mentions")}
        </div>
        <a target="_blank" href={$getTrad('data_rights_link')}>{$getTrad("footer_data_rights")}</a>
        <div class="link" on:click|preventDefault={(e)=>{ setInfoPopup("footer_contact", "footer_contact_popup", e) }} >
          {$getTrad("footer_contact")}
        </div>
      </div>
      <div class="bottom">
        <p>{$getTrad("footer_follow_us")}</p>
        <div class="icons">
          <a on:click={handleRSClick.bind(null, "footer_facebook_link")} target="_blank" href={$getTrad("footer_facebook_link")}   class="icon"><Icon icon={faFacebookSquare} /></a>
          <a on:click={handleRSClick.bind(null, "footer_twitter_link")} target="_blank"  href={$getTrad("footer_twitter_link")}  class="icon"><Icon icon={faTwitter} /></a>
          <a on:click={handleRSClick.bind(null, "footer_linkedin_link")} target="_blank" href={$getTrad("footer_linkedin_link")}  class="icon"><Icon icon={faLinkedinIn} /></a>
          <a on:click={handleRSClick.bind(null, "footer_youtube_link")} target="_blank"  href={$getTrad("footer_youtube_link")}  class="icon"><Icon icon={faYoutube} /></a>
        </div>
      </div>
  </div>
{/if}





<div id="footer" on:click={closeShare} >

  <div class="footer-mobile">
    {#if footerMobileOpened}

      <div class="footer-burger-opened" on:click={toggleFooterMobile}>
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 8.23223L2.13388 0.366117C1.64573 -0.122039 0.854272 -0.122039 0.366117 0.366117C-0.122039 0.854272 -0.122039 1.64573 0.366117 2.13388L8.23223 10L0.366117 17.8661C-0.122039 18.3543 -0.122039 19.1457 0.366117 19.6339C0.854272 20.122 1.64573 20.122 2.13388 19.6339L10 11.7678L17.8661 19.6339C18.3543 20.122 19.1457 20.122 19.6339 19.6339C20.122 19.1457 20.122 18.3543 19.6339 17.8661L11.7678 10L19.6339 2.13388C20.122 1.64573 20.122 0.854272 19.6339 0.366117C19.1457 -0.122039 18.3543 -0.122039 17.8661 0.366117L10 8.23223Z" id="close" fill="#FFFFFF" stroke="none" />
        </svg>
      </div>

    {:else}

      <div class="footer-burger-closed" on:click={toggleFooterMobile}>
        <svg width="25px" height="17px" viewBox="0 0 25 17" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
          <g id="Burger" transform="translate(0.5 0.5)">
            <path d="M0.999 0L23.001 0Q23.0994 0 23.1959 0.0191955Q23.2924 0.038391 23.3833 0.0760443Q23.4742 0.113698 23.556 0.168362Q23.6378 0.223026 23.7074 0.2926Q23.777 0.362175 23.8316 0.443985Q23.8863 0.525796 23.924 0.616699Q23.9616 0.707602 23.9808 0.804105Q24 0.900607 24 0.999L24 1.001Q24 1.09939 23.9808 1.1959Q23.9616 1.2924 23.924 1.3833Q23.8863 1.4742 23.8316 1.55601Q23.777 1.63783 23.7074 1.7074Q23.6378 1.77697 23.556 1.83164Q23.4742 1.8863 23.3833 1.92396Q23.2924 1.96161 23.1959 1.9808Q23.0994 2 23.001 2L0.999 2Q0.900607 2 0.804105 1.9808Q0.707602 1.96161 0.616699 1.92396Q0.525796 1.8863 0.443985 1.83164Q0.362175 1.77697 0.2926 1.7074Q0.223026 1.63783 0.168362 1.55601Q0.113698 1.4742 0.0760443 1.3833Q0.038391 1.2924 0.0191955 1.1959Q0 1.09939 0 1.001L0 0.999Q0 0.900607 0.0191955 0.804105Q0.038391 0.707602 0.0760443 0.616699Q0.113698 0.525796 0.168362 0.443985Q0.223026 0.362175 0.2926 0.2926Q0.362175 0.223026 0.443985 0.168362Q0.525796 0.113698 0.616699 0.0760443Q0.707602 0.038391 0.804105 0.0191955Q0.900607 0 0.999 0Z" id="Rectangle" fill="#FFFFFF" stroke="none" />
            <path d="M0.999 0L23.001 0Q23.0994 0 23.1959 0.0191955Q23.2924 0.038391 23.3833 0.0760443Q23.4742 0.113698 23.556 0.168362Q23.6378 0.223026 23.7074 0.2926Q23.777 0.362175 23.8316 0.443985Q23.8863 0.525796 23.924 0.616699Q23.9616 0.707602 23.9808 0.804105Q24 0.900607 24 0.999L24 1.001Q24 1.09939 23.9808 1.1959Q23.9616 1.2924 23.924 1.3833Q23.8863 1.4742 23.8316 1.55601Q23.777 1.63783 23.7074 1.7074Q23.6378 1.77697 23.556 1.83164Q23.4742 1.8863 23.3833 1.92396Q23.2924 1.96161 23.1959 1.9808Q23.0994 2 23.001 2L0.999 2Q0.900607 2 0.804105 1.9808Q0.707602 1.96161 0.616699 1.92396Q0.525796 1.8863 0.443985 1.83164Q0.362175 1.77697 0.2926 1.7074Q0.223026 1.63783 0.168362 1.55601Q0.113698 1.4742 0.0760443 1.3833Q0.038391 1.2924 0.0191955 1.1959Q0 1.09939 0 1.001L0 0.999Q0 0.900607 0.0191955 0.804105Q0.038391 0.707602 0.0760443 0.616699Q0.113698 0.525796 0.168362 0.443985Q0.223026 0.362175 0.2926 0.2926Q0.362175 0.223026 0.443985 0.168362Q0.525796 0.113698 0.616699 0.0760443Q0.707602 0.038391 0.804105 0.0191955Q0.900607 0 0.999 0Z" transform="translate(0 7)" id="Rectangle-Copy-2" fill="#FFFFFF" stroke="none" />
            <path d="M0.999 0L23.001 0Q23.0994 0 23.1959 0.0191955Q23.2924 0.038391 23.3833 0.0760443Q23.4742 0.113698 23.556 0.168362Q23.6378 0.223026 23.7074 0.2926Q23.777 0.362175 23.8316 0.443985Q23.8863 0.525796 23.924 0.616699Q23.9616 0.707602 23.9808 0.804105Q24 0.900607 24 0.999L24 1.001Q24 1.09939 23.9808 1.1959Q23.9616 1.2924 23.924 1.3833Q23.8863 1.4742 23.8316 1.55601Q23.777 1.63783 23.7074 1.7074Q23.6378 1.77697 23.556 1.83164Q23.4742 1.8863 23.3833 1.92396Q23.2924 1.96161 23.1959 1.9808Q23.0994 2 23.001 2L0.999 2Q0.900607 2 0.804105 1.9808Q0.707602 1.96161 0.616699 1.92396Q0.525796 1.8863 0.443985 1.83164Q0.362175 1.77697 0.2926 1.7074Q0.223026 1.63783 0.168362 1.55601Q0.113698 1.4742 0.0760443 1.3833Q0.038391 1.2924 0.0191955 1.1959Q0 1.09939 0 1.001L0 0.999Q0 0.900607 0.0191955 0.804105Q0.038391 0.707602 0.0760443 0.616699Q0.113698 0.525796 0.168362 0.443985Q0.223026 0.362175 0.2926 0.2926Q0.362175 0.223026 0.443985 0.168362Q0.525796 0.113698 0.616699 0.0760443Q0.707602 0.038391 0.804105 0.0191955Q0.900607 0 0.999 0Z" transform="translate(0 14)" id="Rectangle-Copy-3" fill="#FFFFFF" stroke="none" />
          </g>
        </svg>
      </div>

    {/if}

    <div id="logo"><Logo/></div>

    <div class="footer-share" on:click|stopPropagation={toggleShareMenu}>
      <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
        <g id="Outlined/UI/share">
          <path d="M20.6218 18.7464C19.4065 18.7481 18.2674 19.3386 17.5656 20.3308L7.25309 14.3308C7.40055 13.9439 7.48291 13.5352 7.49684 13.1214C7.49451 12.847 7.46309 12.5736 7.40309 12.3058L17.8093 6.23075C19.0071 7.58883 21.0041 7.89708 22.5556 6.96332C24.107 6.02956 24.7697 4.12056 24.1303 2.4264C23.491 0.732232 21.7324 -0.263111 19.9509 0.0608707C18.1693 0.384853 16.8738 1.93561 16.8718 3.74638C16.8742 4.0208 16.9056 4.29421 16.9656 4.562L6.55934 10.637C5.4163 9.34462 3.53894 8.99893 2.01053 9.79941C0.482116 10.5999 -0.302871 12.3399 0.108519 14.0155C0.519908 15.6911 2.0215 16.8698 3.74684 16.8714C4.66482 16.8746 5.55211 16.5411 6.24059 15.9339L16.8718 22.1214L16.8718 22.4964C16.8718 24.5674 18.5508 26.2464 20.6218 26.2464C22.6929 26.2464 24.3718 24.5674 24.3718 22.4964C24.3718 20.4253 22.6929 18.7464 20.6218 18.7464ZM22.4968 3.74638C22.4968 2.71085 21.6574 1.87138 20.6218 1.87138C19.5863 1.87138 18.7468 2.71085 18.7468 3.74638C18.7468 4.78191 19.5863 5.62138 20.6218 5.62138C21.6574 5.62138 22.4968 4.78191 22.4968 3.74638ZM3.74684 14.9964C2.71131 14.9964 1.87184 14.1569 1.87184 13.1214C1.87184 12.0858 2.71131 11.2464 3.74684 11.2464C4.78237 11.2464 5.62184 12.0858 5.62184 13.1214C5.62184 14.1569 4.78237 14.9964 3.74684 14.9964ZM18.7468 22.4964C18.7468 23.5319 19.5863 24.3714 20.6218 24.3714C21.6574 24.3714 22.4968 23.5319 22.4968 22.4964C22.4968 21.4608 21.6574 20.6214 20.6218 20.6214C19.5863 20.6214 18.7468 21.4608 18.7468 22.4964Z" transform="translate(2.81566 1.878621)" id="Style" fill="#FFFFFF" fill-rule="evenodd" stroke="none" />
        </g>
      </svg>
    </div>

    {#if shareOpened}
      <div class="sharemenu">
        <a
          on:click={handleRSClick.bind(null, "footer_facebook_mobile_share")}
          href={getFacebookLink($getTrad("facebook_start"))}
          target="_blank" class="i" >
            <Icon icon={faFacebookF}></Icon>
        </a>
        <a
          on:click={handleRSClick.bind(null, "footer_twitter_mobile_share")}
          href={getTwitterLink($getTrad("twitter_start"))}
          target="_blank" class="i" >
            <Icon icon={faTwitter}></Icon>
        </a>
        <a
          on:click={handleRSClick.bind(null, "footer_linkedin_mobile_share")}
          href={getLinkedinLink($getTrad("linkedin_start"))}
          target="_blank" class="i" >
            <Icon icon={faLinkedinIn}></Icon>
        </a>
      </div>
    {/if}
  </div>


  <div class="footer-desktop">
    <div id="footer-left">
      <div on:click|preventDefault={(e)=>{ setInfoPopup("footer_about", "footer_about_infopopup", e) }} >
        {$getTrad("footer_about")}
      </div>

      <div on:click|preventDefault={(e)=>{ setInfoPopup("footer_copyrights_popup_title", "footer_copyrights_popup", e) }} >
        {$getTrad("footer_credits")}
      </div>
      <div on:click|preventDefault={(e)=>{ setInfoPopup("footer_mentions", "footer_mentions_popup", e) }} >
        {$getTrad("footer_mentions")}
      </div>
      <a target="_blank" href={$getTrad('data_rights_link')}>{$getTrad("footer_data_rights")}</a>
      <div on:click|preventDefault={(e)=>{ setInfoPopup("footer_contact", "footer_contact_popup", e) }} >
        {$getTrad("footer_contact")}
      </div>

    </div>

    <div id="footer-center">
      <a href={$getTrad("Find_out_SG")} target="_blank">{$getTrad("footer_join_us")}</a>
    </div>

    <div id="footer-icons">
      <span>{$getTrad("footer_follow_us")}</span>
      <a on:click={handleRSClick.bind(null, "footer_facebook_link")} target="_blank" href={$getTrad("footer_facebook_link")} class="icon"><Icon icon={faFacebookSquare} /></a>
      <a on:click={handleRSClick.bind(null, "footer_twitter_link")}  target="_blank" href={$getTrad("footer_twitter_link")} class="icon"><Icon icon={faTwitter} /></a>
      <a on:click={handleRSClick.bind(null, "footer_linkedin_link")} target="_blank" href={$getTrad("footer_linkedin_link")} class="icon"><Icon icon={faLinkedinIn} /></a>
      <a on:click={handleRSClick.bind(null, "footer_youtube_link")}  target="_blank" href={$getTrad("footer_youtube_link")} class="icon"><Icon icon={faYoutube} /></a>
    </div>
    <div id="logo"><Logo/></div>
  </div>
</div>


<style>

  .infopopup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 50px;
    padding-top: 250px;
    padding-bottom: 100px;
    background: #fff;
    overflow-y: auto;
  }

  .infopopup .infopopup-close {
    position: fixed;
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    background: url('../images/blue-close.svg') no-repeat center center;
  }

  .infopopup .infopopup-title {
    text-transform: uppercase;
    font-size: 25px;
  }

  .infopopup .infopopup-title {
    text-transform: uppercase;
    font-size: 25px;
  }

  .infopopup .infopopup-content {
    margin-bottom: 100px;
  }



  .footer-mobile-menu { display: none; }
  .footer-mobile{ display: none; }

  #footer {
    position: relative;
    background: #00458A;
    padding: 20px;
  }

  #footer-left > div {
    color: #FFF;
    display: inline;
  }
  span, a { color: #fff; }

  #footer-left > div::before,
  span::before,
  a::before {
    content: "";
    display: inline-block;
    margin: 0 10px;
    text-decoration: none;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #fff;
    vertical-align: middle;

  }
  #footer-left > div:first-child::before,
  a:first-child::before,
  a.icon::before { display: none; }

  a.icon {
    font-size: 1.2em;
    vertical-align: middle;
    margin: 0 10px;
  }

  .footer-desktop {
    margin-right: 250px;
    display: flex;
  }

  #footer-center { text-align: right; flex-grow: 1; font-weight: bold; }

  #logo {
    display: block;
    position: absolute;
    right: 40px;
    bottom: 0;
    width: 190px;
  }

  @media screen and (max-width: 800px) {
    .infopopup {
      padding-top: 150px;
    }
    .footer-mobile-menu {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      background: #00a7e6;

      padding: 30px;
      padding-bottom: 70px;
      padding-top: 150px;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .footer-mobile-menu .languages {
      position: absolute;
      top: 30px;
      right: 30px;
      color: #fff;
      width: 50px;
      text-align: right;
    }

    .footer-mobile-menu .lang {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .footer-mobile-menu .lang.selected { font-weight: bold; }

    .footer-mobile-menu div.link,
    .footer-mobile-menu a {
      color: #FFF;
      display: block;
      padding: 10px 0;
    }


    a::before { display: none; }

    .footer-mobile-menu .bottom {
      text-align: center;
      color: #fff;
    }
    .footer-mobile-menu .icons {
      display: flex;
      justify-content: space-evenly;
    }

    #footer {
      display: block;
      padding: 10px;
      height: 48px;
    }

    .footer-mobile{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .footer-desktop{ display: none; }

    .footer-share { color: #fff; }


    .sharemenu {
      position: absolute;
      bottom: 48px;
      right: 5px;
      display: flex;
      flex-direction: column;
      background: #00458A;
    }

    .sharemenu a {
      padding: 10px 15px;
      border-bottom: 1px solid #FFF;

    }

    #logo {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      min-width: 88px;
      max-width: 88px;
    }
  }

</style>
